import React, { useRef, useState } from 'react';

// Pie del chat: una sola fila con el clip para adjuntar, la caja (crece hasta
// 4 líneas) y el botón de enviar. Enter envía, Shift+Enter salto de línea.
export default function EntradaMensaje({ onEnviar, onAdjuntar, deshabilitado, maximoCaracteres = 2000 }) {
  const [texto, setTexto] = useState('');
  const ref = useRef(null);

  const ajustarAlto = () => {
    const el = ref.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = Math.min(el.scrollHeight, 96) + 'px';
    }
  };

  const enviar = () => {
    const limpio = texto.trim();
    if (!limpio || deshabilitado) {
      return;
    }
    onEnviar(limpio);
    setTexto('');
    if (ref.current) {
      ref.current.style.height = 'auto';
      ref.current.focus();
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      enviar();
    }
  };

  const vacio = !texto.trim();
  const restantes = maximoCaracteres - texto.length;
  // El aviso aparece solo cuando queda poco, para no distraer en un mensaje corto.
  const mostrarContador = restantes <= 100;

  return (
    <div className="chat-pie">
      <div className="chat-pie-fila">
        <button type="button" className="chat-adjuntar" onClick={onAdjuntar} aria-label="Subir archivo" title="Subir archivo">
          <i className="fas fa-paperclip" aria-hidden="true"></i>
        </button>
        <textarea
          ref={ref}
          className="chat-caja"
          rows="1"
          placeholder="Escribe un mensaje…"
          value={texto}
          onChange={(e) => {
            setTexto(e.target.value);
            ajustarAlto();
          }}
          onKeyDown={onKeyDown}
          maxLength={maximoCaracteres}
          aria-label="Mensaje"
        />
        <button
          type="button"
          className="chat-enviar"
          onClick={enviar}
          disabled={vacio || deshabilitado}
          aria-label="Enviar mensaje"
          title="Enviar (Enter)"
        >
          <i className="fas fa-paper-plane" aria-hidden="true"></i>
        </button>
      </div>
      <div className="chat-pie-ayuda">
        {mostrarContador ? (
          <span className={restantes === 0 ? 'chat-contador-lleno' : 'chat-contador'}>
            {restantes === 0 ? 'Alcanzaste el máximo de ' + maximoCaracteres + ' caracteres' : 'Quedan ' + restantes + ' caracteres'}
          </span>
        ) : (
          'Enter envía · Shift+Enter salto de línea'
        )}
      </div>
    </div>
  );
}
